<button type="button" (click)="showPopover = true" [class]="info?.iconBtnClass" matSuffix mat-icon-button>
  <mat-icon #matIcon>{{iconName}}</mat-icon>
</button>

<app-popover-loader *ngIf="showPopover" [show]="showPopover" [config]="{title: info?.title, desc: info?.desc, eg: info?.eg, class: 'v9'}" (hideel)="showPopover = $event"></app-popover-loader>